import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { NotificationCard } from './NotificationCard';
import { Close } from '../Icons/Close';
import classes from './styles/index.module.scss';

class Notification extends Component {
	componentDidMount() {
		const { id, duration, removeNotification, boxy } = this.props;

		setTimeout(() => {
			!boxy && removeNotification(id);
		}, duration);
	}

	get closeButton() {
		return (
			<button
				type='button'
				className={classes.close}
				onClick={this.onClose}
			>
				<Close
					height={8}
					width={8}
				/>
			</button>
		);
	}

	onClose = () => {
		const { id, removeNotification } = this.props;

		removeNotification(id);
	};

	render() {
		const { success, warning, danger, content, boxy, title, stretch, isRawHtml } = this.props;

		return (
			<NotificationCard
				success={success}
				warning={warning}
				danger={danger}
				content={content}
				boxy={boxy}
				title={title}
				stretch={stretch}
				size='fixed'
				advancedContent={() => this.closeButton}
				isRawHtml={isRawHtml}
			/>
		);
	}
}

Notification.propTypes = {
	id: PropTypes.string,
	content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	duration: PropTypes.number,
	success: PropTypes.bool,
	warning: PropTypes.bool,
	danger: PropTypes.bool,
	boxy: PropTypes.bool,
};

Notification.defaultProps = {
	duration: 3500,
	boxy: false,
};

export { Notification };
